import React, { useState, useEffect } from 'react';
import axios from 'axios';


function BlogCardNote() {

    const [post, setPosts] = useState([])
    const url = "https://us-central1-mediation-server-daf9e.cloudfunctions.net/api/notes";

    useEffect(() => {
        axios.get(url).then(res => {
            console.log(res.data.data)
            setPosts(res.data.data.contents)
        });
    }, [])

    return (
        <div className="h-full w-full min-w-0 flex flex-col items-center bg-white border border-gray-200 rounded-lg shadow transition-shadow duration-300 hover:shadow-xl">

            <div className="w-full min-w-0 flex flex-col justify-between p-4 leading-normal">
                <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">note</h5>
                {post.map((data) => {
                    return (
                        <div key={data.noteUrl} className="w-full min-w-0 text-left py-1 px-4">
                            <p className="text-black">
                                <a href={data.noteUrl} target="_blank" rel="noopener noreferrer" className="nav-underline inline-block max-w-full break-words font-medium text-black"> {data.name} </a>
                            </p>

                            <div className="flex flex-wrap items-center">
                                {data.hashtags.map((tag) => {
                                    return (<p key={tag.hashtag.name} className="bg-gray-100 text-gray-800 text-xs font-medium mr-2 mb-1 px-2.5 py-0.5 rounded">{tag.hashtag.name}</p>)
                                })}
                            </div>
                            <div className="flex items-center">
                                <p>{new Date(data.publishAt).toLocaleDateString()}</p>
                                <i className="fa-solid fa-folder px-2"></i>
                                <p>{data.likeCount}</p>
                            </div>
                        </div>
                    );
                })}

            </div>
        </div>);
}
export default BlogCardNote;